
const aboutMeConfig = [
    {
        id: "resume",
        title: "See my resume here!",
        links: [
            {
                name: "PDFdownload ",
                url: "/resume",
                icon: "PDF Download",
            },
            {
                name: "linkedin",
                url: "https://www.linkedin.com/in/zephyr-conley/",
                icon: "LinkedIn",
            },
        ],
        pdf: "https://drive.google.com/file/d/1oqw8NTNgxCC9e0EoNgI4kEHlBUmAxIa4/preview",
        target: "_blank"
    }
]

export default aboutMeConfig